/**
 * Shared visual tokens for the Soulumo Foundations surface.
 * Extracted so FoundationsHome, CareForMePage and
 * CareForSomeoneElsePage all breathe the same navy + champagne air.
 */
export const TOK = {
  ink: "#0d1f3a",
  bg: "radial-gradient(ellipse at 50% 22%, #1a2e50 0%, #0d1f3a 50%, #060e1f 85%)",
  cream: "#f5ecd9",
  creamStrong: "rgba(245,236,217,0.94)",
  creamDim: "rgba(245,236,217,0.82)",
  creamMist: "rgba(245,236,217,0.55)",
  creamFaint: "rgba(245,236,217,0.38)",
  gold: "#e0a97a",
  goldWarm: "#f0c790",
  goldSoft: "rgba(224,169,122,0.9)",
  goldMist: "rgba(224,169,122,0.24)",
  goldGlow: "rgba(224,169,122,0.32)",
  divider: "rgba(245,236,217,0.09)",
  cardBg: "rgba(245,236,217,0.045)",
  cardBorder: "rgba(245,236,217,0.12)",
};

export const SERIF = '"Playfair Display", "Cormorant Garamond", serif';
export const SANS = '"Manrope", "Helvetica Neue", Helvetica, Arial, sans-serif';
